module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-1-7271fdab6475bf6904baa0bf4d6ed2f3.svg";